import { render, staticRenderFns } from "./BonSortieDetail.vue?vue&type=template&id=2e8b8468&"
import script from "./BonSortieDetail.vue?vue&type=script&lang=js&"
export * from "./BonSortieDetail.vue?vue&type=script&lang=js&"
import style0 from "./BonSortieDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports